import * as React from 'react';
import { FC } from 'react';

interface IconProps {
  color?: string;
  size?: number;
  style?: React.CSSProperties;
}

const ShoppingBag: FC<IconProps> = ({ color = 'white', size = 12, style }) => (
  <svg width={size} height={size} viewBox="-1.2 -2.4 26.4 32.4" fill="none" style={style}>
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M8.53549 6.5C8.7781 4.80385 10.2368 3.5 12 3.5C13.7633 3.5 15.222 4.80385 15.4646 6.5H12H8.53549ZM7.50005 7.5V8C7.50005 8.27614 7.7239 8.5 8.00005 8.5C8.27619 8.5 8.50005 8.27614 8.50005 8V7.5H12H15.5V8C15.5 8.27614 15.7239 8.5 16 8.5C16.2762 8.5 16.5 8.27614 16.5 8V7.5H17.9637C18.2468 7.5 18.4735 7.73489 18.4634 8.01784L18.1069 18H12H5.89322L5.53672 8.01785C5.52661 7.73489 5.75326 7.5 6.0364 7.5H7.50005ZM7.52751 6.5C7.77623 4.25002 9.68377 2.5 12 2.5C14.3163 2.5 16.2239 4.25002 16.4726 6.5H17.9637C18.8131 6.5 19.4931 7.20466 19.4627 8.05354L19.0686 19.0892C19.0206 20.4344 17.9162 21.5 16.5702 21.5H7.42989C6.08391 21.5 4.97952 20.4344 4.93148 19.0892L4.53735 8.05354C4.50704 7.20466 5.18698 6.5 6.0364 6.5H7.52751Z" 
      stroke={color} 
      fill={color}
    />
  </svg>
);

export default ShoppingBag;